import { render, staticRenderFns } from "./UpdateRequestedUserInfo.vue?vue&type=template&id=3611434b&"
import script from "./UpdateRequestedUserInfo.vue?vue&type=script&lang=js&"
export * from "./UpdateRequestedUserInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports